module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Abo buchen ro.d3693ccd.svg";